import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import container from './container.js'
import dropdownList from './dropdownList.js'
import dropdownOpener from './dropdownOpener.js'

export default contract({
  container: array([
    container
  ]),
  dropdownList: array([
    dropdownList
  ]),
  dropdownOpener: array([
    dropdownOpener
  ])
})
